var _path, _rect, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4,14.43v-4.44h-4.7v.35c0,1.11-.9,2-2,2s-2-.89-2-2v-.35h-13.39v.35c0,1.11-.9,2-2,2s-2-.89-2-2v-.35h-4.7v4.44h30.79Z",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 18.43,
    width: 30.79,
    height: 22.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.4,5.99h-6.7v-.87c0-1.11-.9-2-2-2s-2,.89-2,2v.87h-13.39v-.87c0-1.11-.9-2-2-2s-2,.89-2,2v.87H6.6c-1.1,0-2,.89-2,2V42.78c0,1.11,.9,2,2,2H41.4c1.1,0,2-.89,2-2V7.99c0-1.11-.9-2-2-2ZM13.3,9.99v.35c0,1.11,.9,2,2,2s2-.89,2-2v-.35h13.39v.35c0,1.11,.9,2,2,2s2-.89,2-2v-.35h4.7v4.44H8.6v-4.44h4.7Zm-4.7,30.79V18.43h30.79v22.35H8.6Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,18.43v22.35h30.79V18.43H8.6Zm8.64,15.27c0,1.11-.9,2-2,2s-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22Zm8.29,0c0,1.11-.9,2-2,2s-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22Zm0-8.73c0,1.11-.9,2-2,2s-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22Zm8.51,8.73c0,1.11-.9,2-2,2s-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22Zm0-8.73c0,1.11-.9,2-2,2s-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.39,14.48v-4.44h-4.7v.35c0,1.11-.9,2-2,2s-2-.89-2-2v-.35h-13.39v.35c0,1.11-.9,2-2,2s-2-.89-2-2v-.35h-4.7v4.44h30.79Z",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 18.48,
    width: 30.79,
    height: 22.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.39,6.04h-6.7v-.87c0-1.11-.9-2-2-2s-2,.89-2,2v.87h-13.39v-.87c0-1.11-.9-2-2-2s-2,.89-2,2v.87H6.6c-1.1,0-2,.89-2,2V42.83c0,1.11,.9,2,2,2H41.39c1.1,0,2-.89,2-2V8.04c0-1.11-.9-2-2-2ZM13.3,10.04v.35c0,1.11,.9,2,2,2s2-.89,2-2v-.35h13.39v.35c0,1.11,.9,2,2,2s2-.89,2-2v-.35h4.7v4.44H8.6v-4.44h4.7Zm-4.7,30.79V18.48h30.79v22.35H8.6Z",
    fill: outlineColor
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,27.02c-1.1,0-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22c0,1.11-.9,2-2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.01,27.02c-1.1,0-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22c0,1.11-.9,2-2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.21,35.75c-1.1,0-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22c0,1.11-.9,2-2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,35.75c-1.1,0-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22c0,1.11-.9,2-2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.01,35.75c-1.1,0-2-.89-2-2v-.22c0-1.11,.9-2,2-2s2,.89,2,2v.22c0,1.11-.9,2-2,2Z",
    fill: outlineColor
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico-calendar.d4fc71f3da359265fe8fb9025621fae3.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;